const stripTags = require("../quill/stripTags.js");
module.exports = function removeInvalidEvents(eventGroup){
   eventGroup.events = eventGroup.events.filter(event => {
        return event.start !== undefined && event.end !== undefined && stripTags(event.text).trim() !== "";
    });

    return eventGroup;
}